
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/link-demo/identity",
      function () {
        return require("private-next-pages/link-demo/identity.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/link-demo/identity"])
      });
    }
  